import { useEffect, useRef, useState } from 'react';

// URL base da API (services/api.js usa REACT_APP_API_URL + '/api'); o
// endpoint /health vive na raiz do backend (backend/src/app.js), fora do
// /api — por isso remove o sufixo aqui em vez de reusar a instância axios.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const HEALTH_URL = `${API_URL.replace(/\/api\/?$/, '')}/health`;

const PING_INTERVAL_MS = 15000;
const PING_TIMEOUT_MS = 4000;

async function apiEstaViva() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), PING_TIMEOUT_MS);
  try {
    const resp = await fetch(HEALTH_URL, { signal: controller.signal, cache: 'no-store' });
    return resp.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

// navigator.onLine só reflete o link de rede (Wi-Fi/cabo conectado), não
// se o backend está realmente alcançável — por isso soma com um ping
// periódico em /health. "online" aqui significa "consegue falar com a API".
export default function useOnlineStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  const emVooRef = useRef(false);

  useEffect(() => {
    let ativo = true;

    const checar = async () => {
      if (!navigator.onLine) { if (ativo) setOnline(false); return; }
      if (emVooRef.current) return;
      emVooRef.current = true;
      const viva = await apiEstaViva();
      emVooRef.current = false;
      if (ativo) setOnline(viva);
    };

    checar();
    const intervalo = setInterval(checar, PING_INTERVAL_MS);
    window.addEventListener('online', checar);
    window.addEventListener('offline', checar);

    return () => {
      ativo = false;
      clearInterval(intervalo);
      window.removeEventListener('online', checar);
      window.removeEventListener('offline', checar);
    };
  }, []);

  return online;
}
